import { Controller } from "@hotwired/stimulus"

// Shows/hides config sections based on whether their feature checkbox is on.
//
// Wire up:
//   <div data-controller="feature-toggle">
//     <input type="checkbox" data-feature-toggle-target="toggle"
//            data-feature-key="ctwa_enabled"
//            data-action="change->feature-toggle#refresh">
//     <section data-feature-toggle-target="section" data-feature-key="ctwa_enabled">…</section>
//   </div>
//
// A section is visible only when the toggle sharing its data-feature-key is checked.
export default class extends Controller {
  static targets = ["toggle", "section"]

  connect() {
    this.refresh()
  }

  refresh() {
    this.sectionTargets.forEach((section) => {
      const key = section.dataset.featureKey
      const toggle = this.toggleTargets.find((t) => t.dataset.featureKey === key)
      const visible = toggle ? toggle.checked : true
      section.classList.toggle("hidden", !visible)
    })
  }
}
